<script setup>
import {ref, defineProps, onMounted, defineEmits, watch} from "vue"
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid"

const props = defineProps({
  isOpen: { default: true, type: Boolean },
})

const isOpen = ref(true)

onMounted(() => {
  isOpen.value = props.isOpen
})

const emit = defineEmits(['update:isOpen'])

watch(() => props.isOpen, () => {
  isOpen.value = props.isOpen
})

const toggle = () => {
  isOpen.value = !isOpen.value
  emit('update:isOpen', isOpen.value)
}
</script>

<template>
  <button
      class="w-10 h-10 rounded-full hover-button relative overflow-hidden"
      @click="toggle"
      aria-label="Toggle"
  >
    <transition name="chevron" mode="out-in">
      <ChevronUpIcon
          v-if="isOpen"
          key="up"
          class="absolute inset-0 m-auto h-5 w-5"
      />
      <ChevronDownIcon
          v-else
          key="down"
          class="absolute inset-0 m-auto h-5 w-5"
      />
    </transition>
  </button>
</template>

<style scoped>
.chevron-enter-active,
.chevron-leave-active {
  transition: all 180ms ease;
}

.chevron-enter-from {
  opacity: 0;
  transform: rotate(-90deg) scale(0.8);
}

.chevron-leave-to {
  opacity: 0;
  transform: rotate(90deg) scale(0.8);
}
</style>
